<button
  class="btn d-flex justify-content-center align-items-center gap-2"
  [ngClass]="computedBtnClasses()"
  [disabled]="computedDisabledState()"
  type="button"
  [attr.aria-disabled]="computedDisabledState() ? true : null"
  [attr.aria-label]="ariaLabel() || null"
  (click)="buttonClicked.emit()"
>
  @if (loading()) {
    <div
      class="spinner-border"
      style="color: inherit; height: 1em; width: 1em"
      role="status"
    >
      <span class="visually-hidden">{{ computedText() }}</span>
    </div>
  }

  @if (icon(); as icon) {
    @if (!loading()) {
      <mop-icon [size]="computedIconSize()" [name]="icon"></mop-icon>
    }
  }
  @if (!iconOnly()) {
    <div class="btn-text">{{ computedText() }}</div>
  }
</button>
